import React, { useContext } from 'react';
import { LayoutContext } from 'contexts/LayoutContext';
import { UnionPayStackRoutes, UnionPayStackScreenProps } from '@/features/bill-payment/screens/union-pay/type';
import { AccountSelectWebScreen } from '@/features/bill-payment/screens/union-pay/AccountSelectWeb.screen';
import { AccountSelectorNativeModal } from '@/features/bill-payment/screens/union-pay/AccountSelectorNativeModal';

export interface AccountSelectScreenProps {}

export const AccountSelectScreen: React.FC<UnionPayStackScreenProps<UnionPayStackRoutes.AccountSelect>> = ({ navigation, route }) => {
  const layout = useContext(LayoutContext);
  const { onLayout, onBack, onSelect, asset } = route.params;

  if (layout.isMobile) {
    return <AccountSelectorNativeModal onSelect={onSelect} asset={asset} />;
  }
  return <AccountSelectWebScreen onLayout={onLayout} onBack={onBack} onSelect={onSelect} asset={asset} />;
};
